import ChooseAClinicFullScreenMessage from "../../components/fullScreenMessage/ChooseAClinicFullScreenMessage";
import PageContentWrapper from "../../components/wrappers/PageContentWrapper";
import useUser from "../../hooks/useUser";
import AppointmentsTabs from "./components/tabs/components/AppointmentsTabs";

export default function AppointmentsPage() {
  const { currentClinic, booleans, isLoading: isUserLoading } = useUser();
  
  if (!currentClinic?.id && !isUserLoading) {
    return <ChooseAClinicFullScreenMessage />;
  }

  return (
    <PageContentWrapper>
      <AppointmentsTabs />
    </PageContentWrapper>
  );
}
